lmApp
  .service('RegistrationService', ['$q', 'ApiService', function ($q, ApiService) {

    var service = {};

    service.Register = function (user) {
      var deferred = $q.defer();

      var data = {
        email: user.email,
        password: user.password1,
        name: translit(user.name),
        first_name: user.firstName,
        last_name: user.lastName,
        company_name: user.company,
        recaptcha_response: user.recaptchaResponse,
        invite_code: user.invite
      };

      ApiService.Request('1/register', 'POST', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'supervisor/1/register';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.Check = function (email, name) {
      var deferred = $q.defer();

      var urlEmail = '1/operator/exists?email=';
      var urlName = '1/operator/exists?name=';

      var all = {};
      all.email = ApiService.Request(urlEmail);

      all.name = ApiService.Request(urlName);

      $q.all(all)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = '1/operator/exists';
          reason.data = 'GET';
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    return service;
  }]);
